

export function arrayMove(arr:any[], old_index:number, new_index:number) {
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}


export function sortArrayOfObjects( arr:any, sortBy:string, sortDir = "asc"){
  const isString = (typeof arr[0][sortBy] === "string" || arr[0][sortBy] instanceof String);
  arr.sort( (a:any, b:any) => {
    const fa = ( isString ) ? a[sortBy].toLowerCase() : a[sortBy]
    const fb = ( isString ) ? b[sortBy].toLowerCase() : b[sortBy];
    if (fa < fb) return ( sortDir === "asc") ? -1 : 1
    if (fa > fb) return ( sortDir === "asc" ) ? 1 : -1
    return 0;
  });
  return arr
}


export function arraySort(arr:any, prop:string){
  arr.sort( (a:any, b:any) => {
    if(a[prop] > b[prop]) return 1;
    if(a[prop] < b[prop]) return -1;
    return 0;
  })
  return arr
}


export function arraySortNoCase(arr:any[], prop:string){
  arr.sort( (a:any, b:any) => {
    if(a[prop].toLowerCase() > b[prop].toLowerCase()) return 1;
    if(a[prop].toLowerCase() < b[prop].toLowerCase()) return -1;
    return 0;
  })
  return arr
}


export function isArrayOrObject(item:any){
  let isArr = Object.prototype.toString.call(item) === '[object Array]'
  return (isArr) ? "array" : "object"
}



export const arrays = {
  arrayMove,
  sortArrayOfObjects,
  arraySort,
  arraySortNoCase,
  isArrayOrObject
}